import { useAdminPayments } from "../../payments/hooks/useAdminPayments";
import type { ListPaymentsQueryDto } from "../../payments/data/types";

export function usePartnerPayments(partnerId: number, query?: Omit<ListPaymentsQueryDto, "partnerId">) {
  return useAdminPayments({ ...query, partnerId });
}
